import {StrictMode} from 'react';
import {createRoot} from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import App from './App.tsx';
import './index.css';
import { enforceCacheLimit } from './backend/cacheService';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60000,
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
});

// 1. Security Hardening: Log Management (Section 6)
if (import.meta.env.PROD) {
    console.log = () => {};
    console.debug = () => {};
    console.info = () => {};
    // Keep console.error and console.warn for critical issue tracking
}

const startApp = async () => {
  void enforceCacheLimit();
  createRoot(document.getElementById('root')!).render(
    <StrictMode>
      <QueryClientProvider client={queryClient}>
        <App />
      </QueryClientProvider>
    </StrictMode>,
  );
};

void startApp().catch((error: unknown) => {
  const root = document.getElementById('root');
  if (!root) {
    console.error('Application startup failed:', error);
    return;
  }

  root.textContent = error instanceof Error
    ? `YeTryKar could not start: ${error.message}`
    : 'YeTryKar could not start because Firebase initialization failed.';
});
